import _ from 'lodash'

async function autoAddLink(content = '', keywords: any[] = [], title = '') {
  if (!_.isString(content)) return content
  const hostName = 'https://www.jufair.com'
  // 查找所有不替换的内容
  const findNotReplace = async (reg: RegExp, str: string) => {
    return await str.match(reg)
  }

  // 把不替换的内容替换成特殊字符
  const replaceNotContent = async (list: any, content: string, chart: string) => {
    await (list || []).map((item: any, index: any) => {
      content = (content ?? '') != '' ? content.replace(item, chart + index + chart) : content
    })
    return content
  }
  // 替换超链接
  const replaceLinkContent = async (list: any, content: string) => {
    await (list || []).map((item: string) => {
      const regex = /<a.*?>(.*?)<\/a>/gi
      const result = regex.exec(item)
      const temp = (result && result[1].trim()) || ''

      content = (content ?? '') != '' ? content.replace(item, temp) : content
    })
    return content
  }

  // 查找有效关键词
  const findValidKeywords = async (keywords: any[], content: string) => {
    const validKeywords: any[] = []
    await (keywords || []).map((item: { content: string | RegExp }) => {
      const reg = new RegExp(item.content)
      const validKeyword = reg.test(content)
      if (validKeyword) validKeywords.push(item)
    })
    return validKeywords
  }

  // 删除重复链接关键词，保留长尾词
  function delRepeatKerword(validKeywords: any[]) {
    for (let i = 0; i < validKeywords.length; i++) {
      for (let j = i + 1; j < validKeywords.length; j++) {
        if (validKeywords[i].url === validKeywords[j].url) {
          if (validKeywords[i].content.length <= validKeywords[j].content.length) {
            validKeywords.splice(i, 1)
          } else {
            validKeywords.splice(j, 1)
          }
        }
      }
    }
  }

  // 排序
  function quickSort(arr: any[]): any {
    // 如果数组长度小于等于1，则返回数组本身
    if (arr.length <= 1) return arr
    // 定义中间值的索引
    const index = Math.floor(arr.length / 2)
    // 取到中间值
    const temp = arr.splice(index, 1)[0]
    // 定义左右部分数组
    const left = []
    const right = []
    for (let i = 0; i < arr.length; i++) {
      // 如果元素比中间值小，那么放在左边，否则放右边
      if (arr[i].content.length > temp.content.length) {
        left.push(arr[i])
      } else {
        right.push(arr[i])
      }
    }
    return quickSort(left).concat(temp, quickSort(right))
  }

  // 替换关键词
  const replaceKeywords = ({
    keywords,
    content,
    length
  }: {
    keywords: any[]
    content: string
    length: number
  }) => {
    let num = 0
    keywords.map((item: any, index: number) => {
      if (num < length) {
        if (content.includes(item.content)) {
          content =
            (content ?? '') != '' ? content.replace(item.content, '%' + index + '%') : content
          num++
        }
      }
    })
    return content
  }

  // 恢复不替换内容
  const restoreNotContent = async (arr: any, content: string, chart: any) => {
    await (arr || []).map((item: string, index: any) => {
      content =
        (content ?? '') != ''
          ? content.replace(chart + index + chart, item.replace('http://', '//'))
          : content
    })
    return content
  }
  // 恢复图片
  const restoreImg = async (arr: any, content: string, chart: string) => {
    const reg = /\bsrc\b\s*=\s*['"]?([^'"]*)['"]?/gi
    await (arr || []).map((item: string, index: any) => {
      const src = item.match(reg)
      content =
        (content ?? '') != ''
          ? content.replace(
              chart + index + chart,
              `<img ${src && src[0].replace('http://', '//')} data-${
                src && src[0].replace('http://', '//')
              } title='${title}' alt='${title}'>`
            )
          : content
    })
    return content
  }

  const replaceContent = async (list: any, content: string, chart: string) => {
    await (list || []).map((item: { url: any; content: any }, index: any) => {
      const a = `<a target="_blank" href="${hostName}${item.url}" title="${item.content}">${item.content}</a>`
      content = (content ?? '') != '' ? content.replace(chart + index + chart, a) : content
    })
    return content
  }

  try {
    const imgReg = /<img\b.*?(>|\/>)/gi
    const aReg = /<a\b.*?>.*?(\/a>)/gi

    const imgList = await findNotReplace(imgReg, content) // 查找所有图片标签
    const aList = await findNotReplace(aReg, content) // 查找所有A标签

    content = await replaceNotContent(imgList, content, '$') // 替换所有图片内容
    content = await replaceLinkContent(aList, content) // 替换所有超链接内容

    const validKey = await findValidKeywords(keywords, content) // 匹配有效的关键词
    delRepeatKerword(validKey) // 删除重复链接关键词，保留长尾词

    const sortKey = await quickSort(validKey) // 词库排序
    content = await replaceKeywords({ keywords: sortKey, content, length: 3 }) // 替换关键词
    content = await restoreImg(imgList, content, '$') // 还原图片内容
    content = await restoreNotContent(aList, content, '@') // 还原超链接内容
    content = await replaceContent(sortKey, content, '%') // 还原关键词内容
  } catch (e) {
    console.error(e)
  }
  console.log('141-links')
  return content
}

export default autoAddLink
